"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Constants = require("FileManagerCore/Constants");

var _Constants2 = require("../../Constants");

var _loadGoogleDrive = _interopRequireDefault(require("../../utils/loadGoogleDrive"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _getGoogleIntegrationCredentials = _interopRequireDefault(require("../../utils/getGoogleIntegrationCredentials"));

var _GoogleIntegrationScopes = _interopRequireDefault(require("../../enums/GoogleIntegrationScopes"));

var _GoogleToBinaryFormats = _interopRequireDefault(require("../../enums/GoogleToBinaryFormats"));

var _GoogleFormatsToExtensions = _interopRequireDefault(require("../../enums/GoogleFormatsToExtensions"));

var _getIsGoogleDriveFileBinary = _interopRequireDefault(require("../../utils/getIsGoogleDriveFileBinary"));

var CREDENTIALS = (0, _getGoogleIntegrationCredentials.default)();

var GoogleDriveButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GoogleDriveButton, _Component);

  function GoogleDriveButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GoogleDriveButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GoogleDriveButton).call(this, props));
    _this.mounted = false;
    _this.state = {
      status: _Constants.RequestStatus.UNINITIALIZED
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleGoogleApiLoaded = _this.handleGoogleApiLoaded.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleGoogleApiFailedLoad = _this.handleGoogleApiFailedLoad.bind((0, _assertThisInitialized2.default)(_this));
    _this.openGooglePicker = _this.openGooglePicker.bind((0, _assertThisInitialized2.default)(_this));
    _this.handlePickerInteractions = _this.handlePickerInteractions.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(GoogleDriveButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      (0, _loadGoogleDrive.default)().then(this.handleGoogleApiLoaded).catch(this.handleGoogleApiFailedLoad).done();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "getViewsForDrawer",
    value: function getViewsForDrawer(type) {
      var _window = window,
          ViewId = _window.google.picker.ViewId;

      switch (type) {
        case _Constants2.DrawerTypes.IMAGE:
          return [ViewId.PHOTOS, ViewId.DOCS_IMAGES, ViewId.PHOTO_ALBUMS];

        case _Constants2.DrawerTypes.DOCUMENT:
          return [ViewId.DOCUMENTS, ViewId.PDFS, ViewId.PRESENTATIONS, ViewId.SPREADSHEETS];

        default:
          return [ViewId.RECENTLY_PICKED, ViewId.DOCS];
      }
    }
  }, {
    key: "openGooglePicker",
    value: function openGooglePicker(_ref) {
      var _this2 = this;

      var authToken = _ref.authToken,
          useMultiSelect = _ref.useMultiSelect;
      var type = this.props.type;
      var _window2 = window,
          _window2$google$picke = _window2.google.picker,
          Feature = _window2$google$picke.Feature,
          PickerBuilder = _window2$google$picke.PickerBuilder;
      var builder = new PickerBuilder();
      var views = this.getViewsForDrawer(type);

      if (useMultiSelect) {
        builder.enableFeature(Feature.MULTISELECT_ENABLED);
      }

      views.forEach(function (view) {
        return builder.addView(view);
      });
      var pickerBuilder = builder.setOAuthToken(authToken).setDeveloperKey(CREDENTIALS.developerKey).setCallback(function (data) {
        _this2.handlePickerInteractions(data, authToken);
      });

      if (this.props.googleDriveOrigin) {
        pickerBuilder.setOrigin(this.props.googleDriveOrigin);
      }

      var picker = pickerBuilder.build();
      picker.setVisible(true);
    }
  }, {
    key: "handlePickerInteractions",
    value: function handlePickerInteractions(data, authToken) {
      var _this$props = this.props,
          importFile = _this$props.importFile,
          drawerType = _this$props.type;
      var _window3 = window,
          _window3$google$picke = _window3.google.picker,
          Response = _window3$google$picke.Response,
          Action = _window3$google$picke.Action,
          Document = _window3$google$picke.Document,
          Type = _window3$google$picke.Type,
          ServiceId = _window3$google$picke.ServiceId;

      if (data[Response.ACTION] !== Action.PICKED) {
        return;
      }

      data.docs.forEach(function (doc) {
        var serviceId = doc[Document.SERVICE_ID];
        var url = doc[Document.URL];
        var hasThumbnails = serviceId === ServiceId.PHOTOS || serviceId === ServiceId.SEARCH_API && doc[Document.TYPE] === Type.PHOTO;

        if (hasThumbnails) {
          var thumbs = doc[Document.THUMBNAILS];

          if (thumbs && thumbs.length > 0) {
            url = thumbs[thumbs.length - 1].url;
          }
        } else {
          if (_GoogleToBinaryFormats.default.has(doc[Document.MIME_TYPE])) {
            url = "https://www.googleapis.com/drive/v2/files/" + doc[Document.ID] + "/export?alt=media&mimeType=" + _GoogleToBinaryFormats.default.get(doc[Document.MIME_TYPE]);
          } else if (drawerType === _Constants2.DrawerTypes.IMAGE || (0, _getIsGoogleDriveFileBinary.default)(doc)) {
            url = "https://www.googleapis.com/drive/v2/files/" + doc[Document.ID] + "?alt=media";
          } else {
            // export all unsupported files to PDF
            url = "https://www.googleapis.com/drive/v2/files/" + doc[Document.ID] + "/export?alt=media&mimeType=application/pdf";
          }
        }

        var filename = _GoogleToBinaryFormats.default.has(doc[Document.MIME_TYPE]) ? "" + doc[Document.NAME] + _GoogleFormatsToExtensions.default.get(doc[Document.MIME_TYPE]) : doc[Document.NAME];
        importFile({
          url: url,
          name: filename,
          authorization: authToken
        });
      });
    }
  }, {
    key: "handleGoogleApiLoaded",
    value: function handleGoogleApiLoaded() {
      if (this.mounted) {
        window.gapi.load('auth');
        window.gapi.load('picker');
        this.setState({
          status: _Constants.RequestStatus.SUCCEEDED
        });
      }
    }
  }, {
    key: "handleGoogleApiFailedLoad",
    value: function handleGoogleApiFailedLoad() {
      if (this.mounted) {
        this.setState({
          status: _Constants.RequestStatus.FAILED
        });
      }
    }
  }, {
    key: "getAuth",
    value: function getAuth(onAuthorized) {
      var options = {
        client_id: CREDENTIALS.clientId,
        scope: _GoogleIntegrationScopes.default,
        immediate: false
      };
      window.gapi.auth.authorize(options, onAuthorized);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this3 = this;

      var useMultiSelect = this.props.useMultiSelect;
      var token = window.gapi.auth.getToken();
      var authToken = token && token.access_token;

      if (!authToken) {
        this.getAuth(function (_ref2) {
          var access_token = _ref2.access_token,
              error = _ref2.error;

          if (!error) {
            _this3.openGooglePicker({
              useMultiSelect: useMultiSelect,
              authToken: access_token
            });
          }
        });
      } else {
        this.openGooglePicker({
          useMultiSelect: useMultiSelect,
          authToken: authToken
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var status = this.state.status;
      var isLoaded = status === _Constants.RequestStatus.SUCCEEDED;
      return _react.default.createElement(_UIButton.default, {
        use: "link",
        onClick: this.handleClick,
        disabled: !isLoaded
      }, _react.default.createElement(_UIIcon.default, {
        name: "socialGoogleDrive",
        className: "m-right-2"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.actions.addFromGoogleDrive"
      }));
    }
  }]);
  return GoogleDriveButton;
}(_react.Component);

GoogleDriveButton.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants2.DrawerTypes)).isRequired,
  useMultiSelect: _propTypes.default.bool.isRequired,
  importFile: _propTypes.default.func.isRequired,
  googleDriveOrigin: _propTypes.default.string
};
var _default = GoogleDriveButton;
exports.default = _default;
module.exports = exports.default;